import { msg } from '@lingui/core/macro';
import type { MessageDescriptor } from 'shared/i18n';
import type { StyleCategoryId } from './types';

export interface StyleCategoryMeta {
  id: StyleCategoryId;
  /** Translated at the call site with `t(label)`. */
  label: MessageDescriptor;
}

/** Display order + labels for the clipboard chip and the selective-paste checklist. */
export const STYLE_CATEGORIES: StyleCategoryMeta[] = [
  { id: 'fill', label: msg`Заливка` },
  { id: 'stroke', label: msg`Обводка` },
  { id: 'typography', label: msg`Типографика` },
  { id: 'opacity', label: msg`Прозрачность` },
  { id: 'cornerRadius', label: msg`Скругление` },
  { id: 'size', label: msg`Размер` },
];

/**
 * Visual categories (everything except size). Used as the default selection
 * in the selective-paste checklist, where size stays an explicit checkbox.
 */
export const ALL_VISUAL_CATEGORIES: StyleCategoryId[] = ['fill', 'stroke', 'typography', 'opacity', 'cornerRadius'];

/** What "paste style" (the button and Ctrl/⌘+Shift+V) transfers — size included. */
export const ALL_STYLE_CATEGORY_IDS: StyleCategoryId[] = [...ALL_VISUAL_CATEGORIES, 'size'];
